module.exports = __webpack_public_path__ + "img/logo-shallow.8c28c6db.png";